import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRecentJourney } from "../../../Services/journey";
import { useStandaloneHeader, JourneyBackHeader, JourneySubpageCard } from "../shared";
import { JourneySectionHead, ProgressRows } from "../blocks";
import { PROGRESS_COPY } from "../copy";
import "../style.css";

/**
 * Your Progress, in full (/journey/progress — Figma 10880:19687; "View More"
 * from the Journey home). `GET /ARIS/v4/journey/recent`, newest first. Life
 * events only; rows open their `deep_link` when one maps to a screen here.
 */
function Progress() {
  const navigate = useNavigate();
  useStandaloneHeader();
  const [state, setState] = useState({ loading: true, events: [], error: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const payload = await getRecentJourney(50);
        const events = Array.isArray(payload?.events)
          ? payload.events
          : Array.isArray(payload)
          ? payload
          : [];
        if (!cancelled) setState({ loading: false, events, error: false });
      } catch (e) {
        console.error("Failed to load progress", e);
        if (!cancelled) setState({ loading: false, events: [], error: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="journey-page">
      <div className="journey-page__inner">
        <JourneyBackHeader to="/journey" />
        <JourneySubpageCard>
          <JourneySectionHead title={PROGRESS_COPY.title} subtitle={PROGRESS_COPY.subtitle} />
          {state.loading && <div className="journey-card journey-card--status">Loading…</div>}
          {!state.loading && state.error && (
            <div className="journey-card journey-card--status">{PROGRESS_COPY.loadError}</div>
          )}
          {!state.loading && !state.error && state.events.length === 0 && (
            <div className="journey-card journey-card--status">{PROGRESS_COPY.empty}</div>
          )}
          {state.events.length > 0 && (
            <div className="journey-rows">
              <ProgressRows events={state.events} onOpen={(route) => navigate(route)} />
            </div>
          )}
        </JourneySubpageCard>
      </div>
    </div>
  );
}

export default Progress;
